import React, { Component } from "react";

//Common Functions

import { BPMStatistics } from "../../Common/BPMChart";
import { DisplayType } from "../../Common/Statistics/ChartObjects";
import { ChartType } from "../../Common/Statistics/ChartObjects";
import * as pr from "../../../common/PrimeComponents";
import * as ChartHelper from "../../Statistics/ChartExamples";

//import "./CustomCSS/charts.css";
export class DashboardIssues extends Component {
  constructor() {
    super();
    this.state = {
      issues: [
        {
          name: "Laser Machine Fault",
          occurences: "10"
        },
        {
          name: "CNC Saw Fault",
          occurences: "9"
        },
        {
          name: "Operating Instructions Missing",
          occurences: "6"
        },
        {
          name: "Missing equipment",
          occurences: "3"
        },
        {
          name: "Welder Mask broken",
          occurences: "2"
        }
      ]
    };
  }

  componentDidMount = () => {
    this.initialDataRender();
    this.interval = setInterval(() => this.refresh(), 1000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loaded: false, editLoaded: false });

    this.setState({ loaded: true, editLoaded: true });
  };

  refresh = () => {};
  // #endregion

  // #region View
  render() {
    return (
      <pr.Panel header="Top 5 Issues" style={{ height: "100%" }}>
        <pr.DataTable value={this.state.issues}>
          <pr.Column field="name" header="Name" />
          <pr.Column field="occurences" header="# of Occurences" />
        </pr.DataTable>
      </pr.Panel>
    );
  }
  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/UI/DashboardIssues.js